import { FaLock } from 'react-icons/fa';
import './SessionExpiredModal.css';

function SessionExpiredModal({ onLogIn }) {
    return (
        <div className="session-expired-overlay">
            <div className="session-expired-modal">
                <div className="session-expired-icon">
                    <FaLock />
                </div>
                <h2 className="session-expired-title">Session Expired</h2>
                <p className="session-expired-message">
                    Your session has expired due to inactivity. Please log in again to continue.
                </p>
                <button className="session-expired-btn" onClick={onLogIn}>
                    Log In Again
                </button>
            </div>
        </div>
    );
}

export default SessionExpiredModal;
